import APIClient from './index';
import _ from 'lodash';

export const getPost = title => {
  return new Promise((resolve, reject) => {
    APIClient.get(`/BlogPosts/${title}`)
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, ['data', 'error'])));
  });
};

export const getPosts = () => {
  return new Promise((resolve, reject) => {
    APIClient.get(`/BlogPosts`)
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, ['data', 'error'])));
  });
};

export const createPost = () => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/BlogPosts`, {})
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, ['data', 'error'])));
  });
};

export const editPost = (post, body) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`/BlogPosts/${post.id}`, body)
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, ['data', 'error'], 'There was an error editing this blog post.')));
  });
};

export const deletePost = (post, body) => {
  return APIClient.delete(`/BlogPosts/${post.id}`)
    .then(response => response.data)
    .catch(error => console.error(error));
};

export const createBlogElement = (post, type) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/BlogElements`, { Post_id: post.id, type })
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, ['data', 'error'])));
  });
};

export const editBlogElement = (element, body) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`/BlogElements/${element.id}`, body)
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, ['data', 'error'], 'There was an error editing this blog element.')));
  });
};

export const deleteBlogElement = (element, body) => {
  return APIClient.delete(`/BlogElements/${element.id}`)
    .then(response => response.data)
    .catch(error => console.error(error));
};

export const searchForElements = (query, type) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/BlogElements/find`, { query, type })
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, ['data', 'error'])));
  });
};
